var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMainTrackBackImage1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 351,
    viewBox: "0 0 116 351",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 350.239V176.165L58.9929 160.358C68.0618 157.928 77.3835 163.31 79.8136 172.379L114.532 301.951C116.962 311.02 111.58 320.342 102.512 322.772L0 350.239Z",
    fill: "#EFF3F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 223.706V0C4.31563 0.0264777 8.6231 1.6861 11.9159 4.97887L106.769 99.8323C113.408 106.471 113.408 117.235 106.769 123.874L11.9159 218.727C8.62309 222.02 4.31563 223.68 0 223.706Z",
    fill: "#BAD8E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainTrackBackImage1);
export default __webpack_public_path__ + "static/media/mainTrackBackImage1.45c21f3f4ac70eb9d23de54bd5e012d6.svg";
export { ForwardRef as ReactComponent };